import { fetchApi } from '@/config/axiosSetting';
import {
  GetSignatureQueryParamsResponseType,
  GetSignatureQueryParamsType,
} from '@/modules/adjusterReportModules/queries/getSignature/getSignatureQuery.type';

export const getPropertyCulpritSignatureQueryFunction = (
  params: GetSignatureQueryParamsType,
): Promise<GetSignatureQueryParamsResponseType> => {
  return fetchApi.get(
    `/property/reports/${params.id}/accident_users/culprit/images/signature/`,
  );
};
